import { Pipe, PipeTransform } from '@angular/core';
import { DropDownMetaData } from '../models/DropDownMetaData';

@Pipe({
  name: 'DpdAttributeValue',
})
export class AttributeDropDownValuePipe implements PipeTransform {
  transform(
    attributes: { id: number; value: string }[],
    columnName: string,
    drowDownMetaData: DropDownMetaData
  ): any {
    try {
      const attribute = attributes.find(
        (x) => x.id == +columnName.split('#')[0]
      );
      const options = drowDownMetaData[columnName.split('#')[0]];
      if (attribute?.value.includes(',')) {
        const optionsIds = attribute.value.split(',');
        let valueToReturn = '';
        optionsIds.forEach((id) => {
          const label = options.find((x) => x.Code === +id)?.Label;
          if (valueToReturn === '') {
            valueToReturn = label!;
          } else {
            valueToReturn = valueToReturn + `, ${label}`;
          }
        });
        return valueToReturn;
      } else {
        const value = options.find((x) => x.Code == +attribute?.value!);
        return value?.Label;
      }
    } catch (error) {
      return '';
    }
  }
}
